import { AtFaultIdentifierQueryResponseType } from '@/common/queries/selections/atFaultIdentifier/atFaultIdentifierQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const atFaultIdentifierQueryFunction = (): Promise<
  AtFaultIdentifierQueryResponseType[]
> => {
  return fetchApi.get('selection_item/at_fault_identifier/wop_list/');
};
